import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AuthModule } from '@freelancer/auth';
import {
  DatastoreCartItemsModule,
  DatastoreCartsModule,
} from '@freelancer/datastore';
import { PaymentsCart } from './payments-cart.service';

@NgModule({
  imports: [
    AuthModule,
    DatastoreCartsModule,
    DatastoreCartItemsModule,
    RouterModule,
  ],
  providers: [PaymentsCart],
})
export class PaymentsCartModule {}
